import translations from './translations'

translations.add('es', {
    threeDigitsDescription: 'Un grupo independiente de tres dígitos en la parte derecha del reverso de la tarjeta',
    fourDigitsDescription: 'Grupo de cuatro dígitos en la parte delantera hacia la derecha',
    cvcCode: 'CSC/CVV'
})
